export default {"src":"/uk/_next/static/media/retirementPlannerIcon.45efd3ba.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};